import { Accents, Component, Knobs, Story } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  accent: {
    default: '',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
    delimiter: '\n  ',
  },
  value: {
    editor: 'textbox',
    default: '1',
    delimiter: '\n  ',
  },
  name: {
    editor: 'textbox',
    default: 'radioBtn',
    delimiter: '\n  ',
  },
  disabled: {
    editor: 'checkbox',
    default: false,
    delimiter: '\n  ',
  },
  labelStyle: {
    editor: 'textbox',
    default: '',
    delimiter: '\n  ',
  },
  editorStyle: {
    editor: 'textbox',
    default: '',
    delimiter: '\n  ',
  },
  colourScheme: {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
    delimiter: '\n  ',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
    delimiter: '\n  ',
  },
  orientation: {
    editor: 'dropdown',
    editorOptions: ['vertical', 'horizontal', ''],
    default: '',
    delimiter: '\n ',
  },
};

const PlaygroundKnobsReact: Knobs = {
  ...PlaygroundKnobs,
  labelStyle: {
    ...PlaygroundKnobs.labelStyle,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
  editorStyle: {
    ...PlaygroundKnobs.editorStyle,
    qualifierStart: '{',
    qualifierEnd: '}',
  },
};

const PlaygroundKnobsReactNoValue: Knobs = {
  ...PlaygroundKnobsReact,
};

delete PlaygroundKnobsReactNoValue.value;

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'tag-radio-buttons where you can change all the attributes',
  coreComponent_v3: {
    html: `<tag3-radio-buttons {{...knobs}}
>
  <tag3-radio-button value="1">High</tag3-radio-button>
  <tag3-radio-button value="2">Medium</tag3-radio-button>
  <tag3-radio-button value="3">Low</tag3-radio-button>
</tag3-radio-buttons>
`,
    knobs: PlaygroundKnobs,
  },

  reactWrapper_v3: {
    jsx: `<Tag3RadioButtons {{...knobs}}
>
  <Tag3RadioButton value="1">High</Tag3RadioButton>
  <Tag3RadioButton value="2">Medium</Tag3RadioButton>
  <Tag3RadioButton value="3">Low</Tag3RadioButton>
</Tag3RadioButtons>
`,
    knobs: PlaygroundKnobsReact,
  },
};

const DynamicRadios: Story = {
  title: 'Dynamically loaded radios',
  description:
    'tag-radio-buttons where you can change all the attributes and radios are loaded dynamic',
  coreComponent_v3: {
    html: `<tag3-radio-buttons {{...knobs}}
>
</tag3-radio-buttons>
`,
    js: `var radios = document.querySelector('tag3-radio-buttons');

var data = [{value: '1', label: "High"},{value: '2', label: "Medium"},{value: '3', label: "Low"},]

setTimeout(function() {
  radios.radios = data;
  console.log('loaded')
},2000)`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {

      const [radios, setRadios] = React.useState();

      React.useEffect(() => {
        setTimeout(() => {
          setRadios([
            {value: '1', label: 'High'},
            {value: '2', label: 'Medium'},
            {value: '3', label: 'Low'},
          ]);
        },2000)
      })

      return (
        <Tag3RadioButtons {{...knobs}}
        radios={radios}
        >
        </Tag3RadioButtons>
      )
    };
    `,
    knobs: PlaygroundKnobsReact,
  },
};

const RadioSetValue: Story = {
  title: 'Set Value',
  description: 'Manually update the radio value.',
  coreComponent_v3: {
    html: `<tag3-radio-buttons {{...knobs}}
>
  <tag3-radio-button value="1">High</tag3-radio-button>
  <tag3-radio-button value="2">Medium</tag3-radio-button>
  <tag3-radio-button value="3">Low</tag3-radio-button>
</tag3-radio-buttons>

<tag3-simple-button>Set Radio value to 3</tag3-simple-button>

`,
    js: `var radios = document.querySelector('tag3-radio-buttons');
document.querySelector('tag3-simple-button').addEventListener('buttonClick', function(e) {
  radios.value = 3;
})

`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {

      const [value, setValue] = React.useState(1);

      return (
        <React.Fragment>
          <Tag3RadioButtons {{...knobs}}
          value={value}
          radios={[
            {value: '1', label: 'High'},
            {value: '2', label: 'Medium'},
            {value: '3', label: 'Low'},
          ]}>
          </Tag3RadioButtons>

          <Tag3SimpleButton onButtonClick={e => setValue(3)}>Set Radio value to 3</Tag3SimpleButton>
        </React.Fragment>
      )
    };
    `,
    knobs: PlaygroundKnobsReactNoValue,
  },
};

const FocusStory: Story = {
  title: 'Focus',
  description: 'An example of how to focus the radio buttons',
  coreComponent_v3: {
    html: `
    <tag3-radio-buttons value="2">
      <tag3-radio-button value="1">High</tag3-radio-button>
      <tag3-radio-button value="2">Medium</tag3-radio-button>
      <tag3-radio-button value="3">Low</tag3-radio-button>
    </tag3-radio-buttons>
    <tag3-button style="display:block">Focus</tag3-button>
    `,
    js: `
    var button = document.querySelector('tag3-button');
    var radioButtons = document.querySelector('tag3-radio-buttons');
    button.addEventListener('buttonClick', function() {
      radioButtons.focusRadioButtons();
    })
    `,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    const radioButtons = React.useRef(null);
    return (
      <div>
        <Tag3RadioButtons ref={radioButtons} value="2">
          <Tag3RadioButton value="1">High</Tag3RadioButton>
          <Tag3RadioButton value="2">Medium</Tag3RadioButton>
          <Tag3RadioButton value="3">Low</Tag3RadioButton>
        </Tag3RadioButtons>
        <Tag3Button style={{display: 'block'}} text="Focus" onButtonClick={() => radioButtons.current.focusRadioButtons()} />
      </div>
    )
  };`,
  },
};

export const TagRadioButtonDocs: Component = {
  type: 'component',
  name: 'radio-button',
  description: 'Renders a radio-button',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'label',
      description: 'Radio butotn label text',
      type: 'string',
    },
    {
      name: 'value',
      description: 'Radio button value',
      type: 'string',
    },
  ],
  methods: [],
  reactPropOverrides: [],
  events: [
    {
      name: 'radioClick',
      description: 'eventRaise when radio button is clicked',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the radio button',
          type: 'string',
        },
        {
          name: 'value',
          description: 'The value attribute of the radio button',
          type: 'string',
        },
      ],
    },
  ],
  stories: [],
};

export const TagRadioButtonsDocs: Component = {
  type: 'component',
  name: 'radio-buttons',
  description: 'Renders a radio-button collection',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description:
        'Emitted in the pillClick event and used to identify which pill is clicked when used within TagPills',
      type: 'string',
    },
    {
      name: 'value',
      description: 'Radio value',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The colour of the check radio button',
      type: 'string',
    },
    {
      name: 'disabled',
      description: 'Disabled value for radios',
      type: 'boolean',
    },
    {
      name: 'labelStyle',
      description: 'JSX style object in JSON to apply to the label',
      type: 'string',
    },
    {
      name: 'editorStyle',
      description: 'JSX style object in JSON to apply to the radio button',
      type: 'string',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
    {
      name: 'orientation',
      description: 'V3 Only: set preferred orientation for buttons.',
      type: 'vertical | horizontal ',
      default: 'horizontal',
    },
  ],
  methods: [
    {
      name: 'focusRadioButtons',
      description: 'Sets the focus to the radio button',
      parameters: [],
      returnType: 'void',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'radioValueChange',
      description: 'eventRaise when radio button is clicked',
      parameters: [
        {
          name: 'name',
          description: 'The name attribute of the radio button',
          type: 'string',
        },
        {
          name: 'value',
          description: 'The value attribute of the radio button',
          type: 'string',
        },
      ],
    },
  ],
  stories: [PlaygroundStory, DynamicRadios, FocusStory, RadioSetValue],
  childComponents: [TagRadioButtonDocs],
};
